module.exports = __webpack_public_path__ + "img/cns_mac8.a7166a4b.png";